<!-- =========================================================================================
    File Name: CardActions.vue
    Description: Card with actions
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row" v-if='eventInfo'>
    <vx-card class="titlevx-card">
      <h4 class="float-left" style="margin-top: 8px;margin-top: 5px;">
        {{ isPast ? 'Event History' : 'Run Event'}}
      </h4>
      <vs-button v-if='!isPast && isRealAdmin' class="float-right mb-5 ml-2 vs-button-danger" @click="resetEvent()">Reset Event</vs-button>
      <vs-button v-else-if='isPast' style="float:right; mb-5 ml-2" @click="$router.push({ path: '/admin/event/past' })">Back</vs-button>
      <vs-button v-if="showMomReportBtn" @click="downloadMomFile" style="float:right; mb-5 mr-2">Download MOM</vs-button>
    </vx-card>
    <!-- Collapse -->
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <vx-card>
        <!-- <vs-button color="primary" type="filled" class="mr-3 mb-2">Start Event</vs-button>
                <vs-button disabled type="filled" class="mb-2">End Event</vs-button>
        -->
				<template v-if='!isPast && isRealAdmin'>
					<div class="flex justify-between flex-wrap">
						<vs-button
							class="mb-2 mr-3"
							:disabled="event_buttons.pre_start"
							id="pre_start_event"
							@click="eventActionButtons(3)"
						>{{ $t('run_event.pre_start_event') }}
						</vs-button>
						<vs-button
							class="mb-2 mr-3"
							:disabled="event_buttons.close_pre_start"
							id="close_pre_start_event"
							@click="eventActionButtons(0)"
						>{{ $t('run_event.close_pre_start_event') }}
						</vs-button>
					</div>
					<div class="flex justify-between flex-wrap">
						<vs-button
							class="mb-2 mr-3"
							:disabled="event_buttons.start"
							id="start_event"
							@click="eventActionButtons(1)"
						>{{ $t('run_event.start_event') }}</vs-button>
						<vs-button 
							:disabled="event_buttons.end" 
							type="filled" class="mb-2" 
							@click="eventActionButtons(2)"
						>{{ $t('run_event.end_event') }}</vs-button>
					</div>
				</template>

        <p class="mb-1">
          <strong>Event: </strong>
          <template v-if='eventInfo'>{{ eventInfo.event_name }} (check eventpage)</template>
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.inviteURL')}}: </strong>
          {{ url.event }}
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.ghostURL')}}: </strong>
          {{ url.ghost }}
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.starting_at')}}: </strong>
          <template v-if='eventInfo'>{{ eventInfo.event_start_date | moment("calendar") }}</template>
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.ending_at')}}: </strong>
          <template v-if='eventInfo'>{{ eventInfo.event_end_date | moment("calendar") }}</template>
        </p>
        <div v-if="!isPast && isRealAdmin && eventMessage != ''">
          <vs-alert color="rgb(231, 154, 23)" active="true" class="mt-5 text-warning">
            <p class="mb-1 event-msg">
              <b>{{$t('Note')}}:</b> {{ $t(eventMessage) }}
            </p>
          </vs-alert>
        </div>
        <br>
        <p class="mb-1">
          <strong>{{$t('Invited')}}: </strong>
          {{ eventResult.invited ? eventResult.invited : 0 }}
        </p>
        <p class="mb-1">
          <strong>{{$t('Entered')}}: </strong>
          <a href="#" @click="showPopup(1)">{{ eventResult.entered ? eventResult.entered : 0 }}</a>
          <feather-icon
            v-if='!isPast'
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(1,false)"
          />
        </p>
        <p class="mb-1" v-if='!isPast'>
          <strong>{{$t('Entered')}} (RT): </strong>
          <a href="#" @click="showPopup(2)">{{ present_usersRT.length }}</a>
          <feather-icon
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(2,false)"
          />
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.entered_w_right_of_vote')}}: </strong>
          <a href="#" @click="showPopup(3)">
            {{ eventResult.online_right_to_vote ? eventResult.online_right_to_vote : 0 }}
          </a>
          <feather-icon
            v-if='!isPast'
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(3,false)"
          />
        </p>
        <p class="mb-1" v-if='!isPast'>
          <strong>{{$t('event_detail.entered_w_right_of_vote')}} (RT): </strong>
          <a href="#" @click="showPopup(4)">
            {{ rightToVoteuserListRT.length }}
          </a>
          <feather-icon
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(4,false)"
          />
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.entered_wo_right_of_vote')}}: </strong>
          <a href="#" @click="showPopup(5)">
            {{ eventResult.online_without_right_to_vote ? eventResult.online_without_right_to_vote : 0 }}
          </a>
          <feather-icon
            v-if='!isPast'
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(5,false)"
          />
        </p>
        <p class="mb-1" v-if='!isPast'>
          <strong>{{$t('event_detail.entered_wo_right_of_vote')}} (RT): </strong>
          <a href="#" @click="showPopup(6)">
            {{ norightToVoteuserListRT.length }}
          </a>
          <feather-icon
            icon="DownloadCloudIcon"
            svgClasses="w-4 h-4 ml-2 hover:text-danger stroke-current"
            class=""
            :title="$t('ExportList')"
            @click="showPopup(6,false)"
          />
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.weights_of_presents')}}: </strong>
            {{ eventResult.presents_weight ? eventResult.presents_weight : 0 }}
        </p>
        <p class="mb-1">
          <strong>{{$t('event_detail.weights_of_delegates')}}: </strong>
            {{ eventResult.delegated_weight ? eventResult.delegated_weight : 0 }}
        </p>
                <p class="mb-1">
          <strong>{{$t('Absent')}}: </strong>
          {{ eventResult.absent ? eventResult.absent : 0 }}
        </p>
        <p class="mb-1">
          <strong>{{$t('Voted')}}: </strong>
          {{ eventResult.voted ? eventResult.voted : 0 }}
        </p>
      </vx-card>
    </div>

    <!-- Popup Code -->
    <vs-popup class="holamundo" :title="popup.title" :active.sync="popup.show">
      <vs-table
        v-if='popup.show'
        :data="popup.data"
        pagination
        :max-items="10"
        search>
        <template slot="thead">
          <vs-th>{{$t('FirstName')}}</vs-th>
          <vs-th>{{$t('LastName')}}</vs-th>
          <vs-th>{{$t('IdNumber')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
            <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
            <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!--vote, not voted user present popup-->
    <vs-popup class="holamundo" :title="popupVotingUserListTitle" :active.sync="popupVotingUserList">
      <vs-table
        :data="displayPresentVotedNoteVotedUserList"
        pagination
        :max-items="10"
        search>
        <template slot="thead">
          <vs-th>{{$t('FirstName')}}</vs-th>
          <vs-th>{{$t('LastName')}}</vs-th>
          <vs-th>{{$t('IdNumber')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
            <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
            <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!--vote, not voted user present popup-->
    <!--right to vote user present popup-->
    <vs-popup class="holamundo" :title="popupRightToVoteTitle" :active.sync="popupRightToVote" id="righttovotepopup">
      <vs-table
        :data="displayRightToVoteuserList"
        pagination
        :max-items="10"
        search>
        <template slot="thead">
          <vs-th>{{$t('FirstName')}}</vs-th>
          <vs-th>{{$t('LastName')}}</vs-th>
          <vs-th>{{$t('IdNumber')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
            <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
            <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!--right to vote user present popup-->
    <!-- Popup Code -->
    <!-- All Actions -->
    <!--voting details popup-->
    <vs-popup class="holamundo" :title="$t('UsersVoted')" :active.sync="popupActive">
      <vs-table
        :data="userList"
        pagination
        :max-items="10"
        search>
        <template slot="thead">
         	<vs-th>{{$t('FirstName')}}</vs-th>
        	<vs-th>{{$t('LastName')}}</vs-th>
          <vs-th>{{$t('IdNumber')}}</vs-th>
          <vs-th>{{$t('Voted')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>
            <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>
            <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>
            <vs-td :data="data[indextr].value">
              {{ getVoteString(data[indextr]) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!--voting details popup-->
    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancel="clearFields" @accept="exportToExcel()"
               accept-text="Export" @close="clearFields" :active.sync="exportExcelActivePrompt">
      <vs-input v-model="fileName" :placeholder="$t('EnterFileName')" class="w-full"/>
      <vs-select v-model="selectedFormat" :options="formats" class="my-4">
        <vs-select-item :key="indexS" :value="item.value" :text="item.label" v-for="(item,indexS) in formats"/>
      </vs-select>
      <div class="flex">
        <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
        <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancel="clearFields"
               @accept="exportVotesToExcel()"
               accept-text="Export" @close="clearFields" :active.sync="exportVotesPrompt">
      <vs-input v-model="fileName" :placeholder="$t('EnterFileName')" class="w-full"/>
      <vs-select v-model="selectedFormat" :options="formats" class="my-4">
        <vs-select-item :key="indexS" :value="item.value" :text="item.label" v-for="item,indexS in formats"/>
      </vs-select>
      <div class="flex">
        <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
        <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancel="clearFields"
               @accept="exportRateResultToExcel()"
               accept-text="Export" @close="clearFields" :active.sync="exportRateResultPrompt">
      <vs-input v-model="fileName" :placeholder="$t('EnterFileName')" class="w-full"/>
      <vs-select v-model="selectedFormat" :options="formats" class="my-4">
        <vs-select-item :key="indexS" :value="item.value" :text="item.label" v-for="(item,indexS) in formats"/>
      </vs-select>
      <div class="flex">
        <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
        <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt :title="$t('ExportToExcel')" class="export-options" @cancel="clearFields" @accept="exportPresencesStatuses()"
               accept-text="Export" @close="clearFields" :active.sync="exportPresencesStatusesPrompt">
      <vs-input v-model="fileName" :placeholder="$t('EnterFileName')" class="w-full"/>
      <vs-select v-model="selectedFormat" :options="formats" class="my-4">
        <vs-select-item :key="indexS" :value="item.value" :text="item.label" v-for="(item,indexS) in formats"/>
      </vs-select>
      <div class="flex">
        <span class="mr-4">{{$t('CellAutoWidth')}}:</span>
        <vs-switch v-model="cellAutoWidth">{{$t('CellAutoWidth')}}</vs-switch>
      </div>
    </vs-prompt>

    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 md:mt-0" v-for="(vote) in eventVoting" :key="vote.id">
      <vx-card title="Voting Management">
        <template v-if='!isPast'>
          <div v-if="vote.type_of_voting == 4 || vote.type_of_voting == 'Free Text'">
            <feather-icon
              icon="DownloadCloudIcon"
              svgClasses="w-5 h-5 mr-2 hover:text-danger stroke-current"
              class=""
              title="Export Invitee List"
              @click="exportVotesPrompt=true;rateToExport=vote.id;fileName=vote.voting_name;getVoteInfo(vote.id)"
            />
            <span>{{$t('ExportVotes')}}</span>
            <br>
          </div>
          <div>
            <feather-icon
              icon="DownloadCloudIcon"
              svgClasses="w-5 h-5 mr-2 hover:text-danger stroke-current"
              class=""
              title="Export Rate Result Details"
              @click="exportRateResultPrompt=true;rateToExport=vote.id;fileName=vote.voting_name;getRateResult(vote.id)"
            />
            <span>{{$t('ExportResults')}}</span>
            <br>
            <br>
          </div>
        </template>

        <p class="mb-2">
          <strong>{{$t('Voting')}}: </strong>
          {{ vote.voting_name }}
        </p>
        <p class="mb-1">
          <strong>{{$t('Description')}}: </strong>
          <span v-html="vote.voting_description"></span>
        </p>
        <p class="mb-1">
          <strong>{{$t('VoteType')}}: </strong>
          {{ $t(getEventVotingTypeTxt(vote.type_of_voting)) }} - {{ vote.is_secret == 0 ? $t('NonSecret') : $t('Secret') }}
        </p>
        <p class="mb-1" v-if='vote.quorum_type'>
          <strong>{{$t('QuorumType')}}: </strong>
          {{ $t(vote.quorum_type.quorum_type) }}
        </p>
        <br>

				<template v-for='(vr) in votingResult'>
					<table class="vx-col lg:w-full" v-if='vr.event_voting_id == vote.id' :key='vr.event_voting_id'>
						<tr>
							<td valign="top" width="50">
								<p class="mb-1">
									<strong>{{$t('Invited')}}:</strong>
									{{ eventResult.invited ? eventResult.invited : 0 }}
									<feather-icon
										icon="DownloadCloudIcon"
										svgClasses="w-5 h-5 ml-2 hover:text-danger stroke-current"
										class=""
										title="Export Invitee List"
										@click="exportPresencesStatusesPrompt=true;rateToExport=vote.id;fileName=vote.voting_name;getPresentsStatus(vote.id)"
									/>
								</p>
								<p class="mb-1">
									<strong>{{$t('Present')}}:</strong>
									{{ vr.present }}
								</p>
								<p class="mb-1">
									<strong>{{$t('Absent')}}:</strong>
									{{ vr.absent }}
								</p>
								<p class="mb-1">
									<strong>{{$t('TotalVotings')}}:</strong>
									{{ vr.voted }}
								</p>
								<p class="mb-1">
									<strong>{{$t('VotedOutOfPresent')}}:</strong>
									<a href="#" @click="showVotedUserList(vote.id,'voted')">
										{{ vr.present_voted ? vr.present_voted : 0 }}
									</a>
								</p>
								<p class="mb-1">
									<strong>{{$t('NotVotedOutOfPresent')}}:</strong>
									<a href="#" @click="showVotedUserList(vote.id,'notvoted')">
										{{ vr.present_not_voted ? vr.present_not_voted : 0 }}
									</a>
								</p>
								<p class="mb-1">
									<strong>{{$t('Abstained')}}: </strong>
									{{ vr.not_answered }}
								</p>
								<div v-if="vote.type_of_voting == 3 || vote.type_of_voting == 'Yes/No'">
									<p class="mb-1">
										<strong>{{$t('VotedYes')}}: </strong>
										{{ vr.yesVotes }}
									</p>
									<p class="mb-1">
										<strong>{{$t('VotedNo')}}: </strong>
										{{ vr.noVotes }}
									</p>
									<p class="mb-1">
										<strong>{{$t('VotedAbstained')}}:</strong>
										{{ vr.abstained }}
									</p>
								</div>
								<div v-if="vote.type_of_voting == 1 || vote.type_of_voting == 'Candidate'">
									<p>
										<table class="candidate-names" style="text-align: left !important;">
											<tbody>
												<tr v-for="(candidate,key) in vr.candidateResult" :key="key">
													<td class="float-left"><strong>Voted {{ candidate.candidate_name }} : </strong></td>
													<td><span class="float-right">{{ candidate.total_votes }}</span></td>
												</tr>
											</tbody>
										</table>
									</p>
								</div>
								<br>
								<p class="mb-1">
									<strong>{{$t('Quorum')}}: </strong>
									<span
										v-if="vr.quorum == true"
										style="border-radius: 50px;background-color:green;padding: 5px 14px;color:#fff"
									>{{ $t('Passed') }}</span>
									<span
										v-else-if="vr.noVotes == vr.yesVotes"
										style="border-radius: 50px;background-color:red; padding: 5px 14px;color:#fff"
									>{{ $t('Parity') }}</span>
									<span
										v-else
										style="border-radius: 50px;background-color:red; padding: 5px 14px;color:#fff"
									>{{ $t('Failed') }}</span>
								</p><br>
								<p v-if="vote.is_secret == 0 || (vote.status == 2 && vr.present_voted > 0)">
									<span @click="openDetails(vote.id)" style="cursor: pointer;">{{$t('VotingInfo')}}</span>
									<feather-icon
										icon="DownloadCloudIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-5"
										title="Export Invitee List"
										@click="exportExcelActivePrompt=true;rateToExport=vote.id;fileName=vote.voting_name"
									/>
								</p>
								<p v-else><br></p>
							</td>
							<td valign="top" width="50">
								<div v-if="vote.type_of_voting == 3 || vote.type_of_voting == 'Yes/No'">
									<div>
										<h4>{{ $t('Preferences') }}</h4>
										<br/>
										<p>
											{{ $t('Yes') }} :
											<span class="float-right">{{ vr.yesVotes }}</span>
											<br/>
											<strong>{{
													parseInt(vr.voted) > 0 ? (Math.round((vr.yesVotes / vr.voted * 100) * 100) / 100).toFixed(2) : '0.00'
												}}%</strong>
											<vs-progress
												class="block mt-1"
												:percent="parseInt(vr.voted) > 0 ? parseInt(Math.round((vr.yesVotes / vr.voted * 100 ) * 100) / 100): 0"
												color="primary"
											></vs-progress>
										</p>
										<br/>
										<p>
											{{ $t('No') }} :
											<span class="float-right">{{ vr.noVotes }}</span>
											<br/>
											<strong>{{
													parseInt(vr.voted) > 0 ? (Math.round((vr.noVotes / vr.voted * 100) * 100) / 100).toFixed(2) : '0.00'
												}}%</strong>
											<vs-progress
												class="block mt-1"
												:percent="parseInt(vr.voted) > 0 ? parseInt(Math.round((vr.noVotes / vr.voted * 100 ) * 100) / 100) : 0"
												color="primary"
											></vs-progress>
										</p>
										<br/>
										<p v-if="vote.is_secret == 1">
											{{ $t('Abstained') }} :
											<span class="float-right">{{ vr.abstained }}</span>
											<br/>
											<strong>{{
													parseInt(vr.voted) > 0 ? (Math.round((vr.abstained / vr.voted * 100) * 100) / 100).toFixed(2) : '0.00'
												}}%</strong>
											<vs-progress
												class="block mt-1"
												:percent="parseInt(vr.voted) > 0 ? parseInt(Math.round((vr.abstained / vr.voted * 100 ) * 100) / 100): 0"
												color="primary"
											></vs-progress>
										</p>
									</div>
								</div>
							</td>
							<td valign="top" width="50">
								<div v-if="vote.type_of_voting == 2 || vote.type_of_voting == 'Option'">
									<h4>{{ $t('Preferences') }}</h4>
									<br/>
									<div v-for="(option,key) in vr.optionResult" :key="key">
										<p>
											{{ option.options }} :
											<span class="float-right">{{ option.total_votes }}</span>
											<br/>
											<strong>{{
													parseInt(vr.voted) > 0 ? (Math.round((option.total_votes / vr.voted * 100) * 100) / 100).toFixed(2) : '0.00'
												}}%</strong>
											<vs-progress
												class="block mt-1"
												:percent="parseInt(vr.voted) > 0 ? parseInt(Math.round((option.total_votes / vr.voted * 100 ) * 100) / 100): 0"
												color="primary"
											></vs-progress>
										</p>
										<br/>
									</div>
								</div>
							</td>
						</tr>
					</table>
				</template>

				<template v-if='!isPast && isRealAdmin'>
        	<br/>
					<div v-if="vote.status != 2 && vote.status != 3 && vote.status != 4">
						<div class="flex justify-between flex-wrap">
							<vs-button
								class="mb-2 mr-3 start_vote_btn"
								:disabled="eventInfo.status == 3 || eventInfo.status == 2 || eventInfo.status == 0 || vote.status != 0"
								@click="startVotingEvent(vote.id)"
								:id="'vote_start_' + vote.id"
							>{{$t('run_event.start_voting')}}
							</vs-button>
							<div class="mb-2 float-right">
								<b class="mr-2">
									<event-voting-countdown :key='vote.id' :event_voting_id='vote.id'></event-voting-countdown>
								</b>
								<vs-button
									:disabled="eventInfo.status == 2 || eventInfo.status == 0 ? true: vote.status != 0 ? false: true"
									type="filled"
									class="end_vote_btn"
									:id="'vote_end_' + vote.id"
									@click="endVotingEvent(vote.id)"
								>{{$t('run_event.end_voting')}}
								</vs-button>
							</div>
							
						</div>
						<vs-alert color="rgb(231, 154, 23)" active="true" class="mt-5 text-warning">
							<p class="mb-1">
								<b>{{$t('Note')}}:</b> <span :class="'vote_msg_'+vote.id">{{ $t('run_event.votingMessage') }}</span>
							</p>
						</vs-alert>
					</div>
					<div class='' >
						<div class="flex justify-between flex-wrap">
							<vs-button
								v-if="eventInfo.status!=2 && (vote.status == 2 || vote.status == 3 || vote.status == 4)"
								class="mb-2"
								@click="repeatVotingEvent(vote)"
							>{{$t('run_event.repeat_voting')}}
							</vs-button>
							<vs-button
								v-if="vote.status == 2 ||  vote.status == 3"
								type="filled "
								:id="'vote_hide_'+ vote.id"
								class="mb-2"
								@click="hideVotingEvent(vote.id)"
							>{{$t('run_event.hide_voting')}}
							</vs-button>
							<vs-button
								v-if="vote.status == 2"
								class="mb-2"
								@click="publishVoting(vote.id)"
								:id="'vote_publish_'+ vote.id"
							>{{$t('run_event.publish_voting')}}
							</vs-button>
						</div>
					</div>
					<br><br>
				</template>

      </vx-card>
      <br>
      <!--      &lt;!&ndash;voting details popup&ndash;&gt;-->
      <!--      <vs-popup class="holamundo" title="Users Voted" :active.sync="popupActive">-->
      <!--        <vs-table-->
      <!--          :data="userList"-->
      <!--          pagination-->
      <!--          :max-items="10"-->
      <!--          search>-->
      <!--          <template slot="thead">-->
      <!--            <vs-th>First Name</vs-th>-->
      <!--            <vs-th>Last Name</vs-th>-->
      <!--            <vs-th>ID Number</vs-th>-->
      <!--            <vs-th>Voted</vs-th>-->
      <!--          </template>-->

      <!--          <template slot-scope="{data}">-->
      <!--            <vs-tr :key="indextr" v-for="(tr, indextr) in data">-->
      <!--              <vs-td :data="data[indextr].first_name">{{ data[indextr].first_name }}</vs-td>-->
      <!--              <vs-td :data="data[indextr].last_name">{{ data[indextr].last_name }}</vs-td>-->
      <!--              <vs-td :data="data[indextr].id_number">{{ data[indextr].id_number }}</vs-td>-->
      <!--              <vs-td :data="data[indextr].value">-->
      <!--                {{ getVoteString(data[indextr]) }}-->
      <!--              </vs-td>-->
      <!--            </vs-tr>-->
      <!--          </template>-->
      <!--        </vs-table>-->
      <!--      </vs-popup>-->
      <!--      &lt;!&ndash;voting details popup&ndash;&gt;-->
    </div>
    
    <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 md:mt-0" v-for="(agenda,index1) in eventAgenda" :key="index1">
      <vx-card title="Event Agenda Management">
        <p class="mb-2">
          <strong>{{$t('Title')}}:</strong>
          {{ agenda.title }}
        </p>
        <p class="mb-2">
          <strong>{{$t('Name')}}:</strong>
          {{ agenda.name }}
        </p>
        <p class="mb-1">
          <strong>{{$t('Description')}}: </strong>
          <span v-html="agenda.description"></span>
        </p>
        <!-- <p class="mb-1"> -->
				<div class="mb-1" v-if="agenda.attachment != null">
					<strong>{{$t('Attachments')}}: </strong>
					<div v-for="(attach, index2) in agenda.attachment.split(',')" :key="index2">
						<a :href="eventInfo.event_agenda_path + '/'+ agenda.id + '/' + attach" type="download">{{ attach }}</a>
					</div>
				</div>
        <!-- </p> -->
        <br>
        <div v-if="agenda.status != 4" class="flex  justify-between flex-wrap">
          <vs-button
            type="filled float-left agenda-btn"
            :id="'agenda_hide_'+ agenda.id"
            :disabled="eventInfo.status == 1 ? false : true"
            class="mb-2"
            @click.prevent="hideAgenda(agenda.id)"
          >{{$t('HideAgenda')}}
          </vs-button>
          <vs-button
            v-if="agenda.status != 1"
            :disabled="eventInfo.status == 1 ? false : true"
            class="float-right agenda-btn"
            @click.prevent="publishAgenda(agenda.id)"
            :id="'agenda_publish_'+ agenda.id"
          >{{$t('PublishAgenda')}}
          </vs-button>
        </div>
      </vx-card>
      <br><br>
    </div>
    <!--Agenda--->

    <vx-card class="titlevx-card" v-show="is_bne == 1 && bne_api && showStreamRecordBtns && bne_activated">
      <vs-button :disabled='eventInfo.is_streaming_started==0 || is_recording_status==1' class="float-left mb-5 start-recording" @click.prevent="updateRecordingStatus(1)">{{ $t('run_event.start_recording') }}</vs-button>
      <vs-button :disabled='eventInfo.is_streaming_started==0 || is_recording_status==0' class="float-left mb-5 ml-2 stop-recording" @click.prevent="updateRecordingStatus(0)">{{ $t('run_event.stop_recording') }}</vs-button>
      <vs-button :disabled='eventInfo.is_streaming_started==0' class="float-right mb-5 ml-2 stop-streaming" @click.prevent="stopStreaming">{{ $t('run_event.stop_streaming') }}</vs-button>
      <vs-button :disabled='eventInfo.is_streaming_started==1' class="float-right mb-5 start-streaming" @click.prevent="startStreaming">{{ $t('run_event.start_streaming') }}</vs-button>
    </vx-card>
    <!-- Admin Event Observer -->
    <div class="vx-col w-full" v-if='!isPast && isEventFetched'>
      <EventInactive v-if='[0,2,3].indexOf(eventInfo.status) > -1'></EventInactive>
      <div v-show='[1,3].indexOf(eventInfo.status) > -1'>
        <!-- EVENT IS PRESTARTED OR STARTED -->
        <EventConference></EventConference>
        <EventParticipants :slug='eventInfo.slug'></EventParticipants>
        <!-- EVENT IS STARTED -->
        <EventVoting v-if='eventInfo.status == 1'></EventVoting>
        <!-- \ EVENT IS STARTED -->
        <!-- \ EVENT IS PRESTARTED OR STARTED -->
      </div>
    </div>
    <!-- \Admin Event Observer -->
  </div>
</template>
<style scoped>
  .show-seprator {
    border-bottom: 1px;
  }
</style>

<script>
import $ from "jquery";
import EventInactive from '../../components/event-inactive';
import EventConference from '../../components/event-conference';
import EventParticipants from '../../components/event-participants';
import EventVoting from '../../components/event-voting';
import EventVotingCountdown from '../../components/event-voting-countdown';
import { mapGetters } from 'vuex';

export default {
  components: { EventInactive, EventConference, EventParticipants, EventVoting, EventVotingCountdown },
  data() {
    return {
      is_recording_status: 0,
			showStreamRecordBtns: false,
			showMomReportBtn: false,
      popup: {
        title:null,
        show: false,
        data: []
      },
      rateToExport: 0,
      event_id: null,
      voteInfo: [],
      rateResultInfo: [],
      start_voting: true,
      end_voting: true,
      is_bne: true,
      // eventVoting: [],
      apiObj: [],
      voting_id: "",
      statusCheck: "",
      eventResult: {},
      eventMessage: 'run_event.eventMessageStart',
      votingResult: [],
      votingResultIv: [],
      userList: [],
      popupActive: false,
      // userVotedList: [],
      // candidateResult: [],
      // optionResult: [],
      present_users: [],
      // popupActiveUserList: false,
      eventAgenda: [],
      presentVotedUserList: [],
      presentNotVotedUserList: [],
      displayPresentVotedNoteVotedUserList: [],
      popupVotingUserList: false,
      popupVotingUserListTitle: '',
      rightToVoteuserList: [],
      norightToVoteuserList: [],
      displayRightToVoteuserList: [],
      popupRightToVote: false,
      popupRightToVoteTitle: this.$t('UserList'),
      fileName: '',
      formats: [
        {value: 'xlsx', label: 'Excel', isSelected: true},
        {value: 'txt', label: 'Text', isSelected: false},
        {value: 'csv', label: 'Csv', isSelected: false},
      ],
      exportExcelActivePrompt: false,
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['FirstName', 'LastName', 'IdNumber', 'Vote'].map(t => this.$t(t)),
      headerVal: ['first_name', 'last_name', 'id_number', 'value'],
      exportVotesPrompt: false,
      exportRateResultPrompt: false,
      exportPresencesStatusesPrompt: false,
      votesHeaderTitle: ['FirstName', 'LastName', 'UpdatedAt', 'VotedText', 'Candidate'].map(t => this.$t(t)),
      votesHeaderVal: ['first_name', 'last_name', 'updated_at', 'voted_text', 'candidate'],
      rateResultHeaderTitle: ['Opzione', 'Numero di voti'],
      rateResultHeaderVal: ['candidate', 'votes'],
      presencesStatusesHeaderTitle: ['Utente', 'Id Utente', 'Stato'],
      presencesStatusesHeaderVal: ['user', 'userId', 'status'],
    };
  },
  computed: {
		...mapGetters([
      'event_listener',
			'isRealAdmin'
		]),
    bne_activated() { return this.$store.state.event.bne_activated },
    bne_api() {
      return this.$store.state.event.bne_api;
    },
    isPast() {
      return this.$route.meta.pastEvent
    },
		eventVoting() {
			// maintain position as per event_voting_id
			return this.$store.state.event.event_voting
      .filter(v => v.type=='voting')
      .map(v => {
        if(v.quorum_types.length > 0){
          if(this.$i18n.locale == 'it')
            v.quorum_type =  v.quorum_types[0]
          else
            v.quorum_type = v.quorum_types[0];
        }else
          v.quorum_type = null;
        return v;
      })
			.sort((a,b) => a.id - b.id);
		},
    isEventFetched() {
      return this.eventInfo ? true : false;
    },
    event_buttons() {
      let event_buttons = {
        pre_start: true,
        close_pre_start: true,
        start: true,
        end: true
      }; 
      if(!this.isRealAdmin || !this.eventInfo)
        return event_buttons;
      return {
        pre_start: [1,2,3].includes(this.eventInfo.status),
        close_pre_start: [1,2,0].includes(this.eventInfo.status),
        start: [1,2,0].includes(this.eventInfo.status),
        end: [0,2,3].includes(this.eventInfo.status),
      }
    },
    // participants() {
    //   return this.$store.state.event.participants.filter(p => p.online);
    // },
    onlineUserIds() {
      return this.$store.state.event.participants.filter(p => p.online)
      .map(p => p.user_id);
    },
    present_usersRT() {
      return this.present_users
      .filter(user => this.onlineUserIds.indexOf(user.id) > -1);
    },
    rightToVoteuserListRT() {
      return this.rightToVoteuserList
      .filter(user => this.onlineUserIds.indexOf(user.id) > -1);
    },
    norightToVoteuserListRT() {
      return this.norightToVoteuserList
      .filter(user => this.onlineUserIds.indexOf(user.id) > -1);
    },
    eventInfo() {
      return this.$store.state.event.event_detail;
    },
    url() {
      const url = {event: null, ghost: null};
      if (this.eventInfo && window.location.origin != '') {
        url.event = window.location.origin + "/event/" + this.eventInfo.slug;
        url.ghost = window.location.origin + "/ghost/event/" + this.eventInfo.slug;
      }
      return url
    },
  },
  watch: {
    event_listener: function(listen) {
      if(listen && listen.key=='EventStatus')
        this.getEventStatus();
		},
    bne_api: function(api,old) {
      if(old==null && api) {
        api.on('recordingStatusChanged', res => {
          if(res.mode=='stream')
					  this.updateStreamingStatus(res.on?1:0);
				});
      }
    }
  },
  async beforeMount() {
		await this.$store.dispatch("GetVotingTypes");
    this.event_id = this.$route.params.id;
    await this.getEventDetails();
    await this.$store.dispatch("GetEventUsers", this.event_id)
    await this.getEventResult();
    this.getEventStatus();
    this.$store.dispatch('ParticipantJoinPresence', this.event_id);

    // socket io to get run time data
    window.Echo.private('eventResult' + this.event_id)
    .listen('EventVotingResult', response => {
      this.eventSocektResult(response);
    })
    .listen('VotingResult', response => {
			this.votingSocketResult(response);
    });
  },
  beforeDestroy() {
    window.Echo.leave('eventResult' + this.event_id);
  },
  methods: {
    updateStreamingStatus(status){
			var data = {event_id: this.event_id, status: status};
			this.$vs.loading();
      this.$store
        .dispatch("ChangeStreamingStatus", data)
        .then(response => {
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : updateStreamingStatus() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
		},
		startStreaming: function(){
      if(!this.bne_api)
        return false;
      this.bne_api.executeCommand("startRecording", {
        mode: "stream",
        youtubeStreamKey: "symposium-"+this.eventInfo.conference_key,
      })
    },
		stopStreaming: function(){
      if(this.bne_api)
     	  this.bne_api.executeCommand('stopRecording', 'stream')
    },
		updateRecordingStatus(status){
			var data = {event_id: this.event_id, status: status};
			this.$vs.loading();
      this.$store
        .dispatch("ChangeRecordingStatus", data)
        .then(response => {
          this.voteInfo = response.data.data;
          this.$vs.loading.close();
          this.is_recording_status = Number(status);
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : updateRecordingStatus() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
		},
		getEventVotingTypeTxt(type_of_voting) {
			// console.log('getEventVotingTypeTxt', type_of_voting);
			type_of_voting = `${type_of_voting}`.toLowerCase();
			const obj = this.$store.state.event.voting_types.find(v => v.id==type_of_voting || v.event_voting_type.toLowerCase() == type_of_voting);
      // console.log(obj)
			if(obj)
				return obj.event_voting_type;
			return '';
		},
		/**
     * Get event status (called this function every 5 sec)
     * @author Madhura Shah
     */
    async getEventStatus(end_voting_id = null) {
      try{
        const data = {
          event_id: this.eventInfo.id,
          user_id: this.$store.getters.currentUser.id
        };
        const res = await this.$store.dispatch("getEventStatus", data)
      }catch(error){
				console.log(error)
        this.$log.error('File : Event.vue | Function : getEventStatus() | Error :', error);
        // Error response
        this.$vs.notify({
          title: this.$t("EventInfoError"),
          text: error,
          color: "danger",
          position: "top-center"
        });
      }
			this.$vs.loading.close();
    },
    showPopup(cond, show=true) {
      switch (cond) {
        case 1: // entered
          Object.assign(this.popup,{
            show:show, title: this.$t('run_event.modal_titles.enteredUserList'), data: this.present_users
          });
          break;
        case 2: // entered RT
          Object.assign(this.popup, {
            show:show, title: this.$t('run_event.modal_titles.enteredUserList')+" (RT)", data: this.present_usersRT
          });
          break;
        case 3: // right of vote
          Object.assign(this.popup, {
            show:show, title: this.$t('run_event.modal_titles.enteredUserListRTV'), data: this.rightToVoteuserList
          });
          break;
        case 4: // right of vote RT
          Object.assign(this.popup, {
            show:show, title: this.$t('run_event.modal_titles.enteredUserListRTV')+" (RT)", data: this.rightToVoteuserListRT
          });
          break;
        case 5: // no right of vote
          Object.assign(this.popup, {
            show:show, title: this.$t('run_event.modal_titles.enteredUserListWRTV'), data: this.norightToVoteuserList
          });
          break;
        case 6: // no right of vote RT
          Object.assign(this.popup, {
            show:show, title: this.$t('run_event.modal_titles.enteredUserListWRTV')+" (RT)", data: this.norightToVoteuserListRT
          });
          break;
        default:
          break;
      }

      if(!show) {
        import('@/utils/Export2Excel').then(excel => {
          const data = [];
          this.popup.data.forEach(user => {
            console.log('export',user)
            data.push([user.first_name, user.last_name, user.id_number, user.present_weight, user.delegated_weight, +user.present_weight + +user.delegated_weight])
          });
          excel.export_json_to_excel({
            header: ["FirstName", "LastName", "IdNumber", "PresentWeight", "DelegatedWeight", "TotalWeights"].map(t => this.$t(t)),
            data,
            filename: this.popup.title + "." + this.selectedFormat,
            autoWidth: true,
            bookType: this.selectedFormat
          })
        });
      }
    },
    getVoteString(data) {
      var str = '';
      if (Array.isArray(data.value)) {
        str = data.value.join(', ');
      } else if (data.value === 1) {
        str = 'Yes';
      } else if (data.value === 2) {
        str = 'No';
      } else if (data.isAbsteined) {
        str = 'Abstained';
      } else {
        str = '---';
      }
      return str;
    },
    /**
     * Open popup
     * @author Madhura Shah
     */
    showVotedUserList(vote_id, type) {
			const vr = this.votingResult.find(vr => vr.event_voting_id==vote_id);
	
      this.popupVotingUserList = true;
      if (type == "voted") {
        this.popupVotingUserListTitle = "Users Present And Voted";
        this.displayPresentVotedNoteVotedUserList = vr ? vr.present_voted_users : [];
      }
      if (type == "notvoted") {
        this.popupVotingUserListTitle = "Users Present And Not Voted";
        this.displayPresentVotedNoteVotedUserList = vr ? vr.present_not_voted_users : [];
      }
    },

    /**
     * Open popup
     * @author Madhura Shah
     */
    showUserList(type) {
      this.popupRightToVote = true;
      if (type == "with_right_to_vote") {
        this.popupRightToVoteTitle = "Users Entered With Right To Vote";
        this.displayRightToVoteuserList = this.rightToVoteuserList;
      }
      if (type == "without_right_to_vote") {
        this.popupRightToVoteTitle = "Users Entered Without Right To Vote";
        this.displayRightToVoteuserList = this.norightToVoteuserList;
      }
    },

    /**
     * Open popup
     * @author Madhura Shah
     */
    openDetails(id) {
      this.userList = [];
			const vr = this.votingResult.find(vr => vr.event_voting_id == id);
      this.userList = vr ? vr.userVotedList : [];
      this.popupActive = true;
    },

    /**
     * Get event Result
     * @author Madhura Shah
     */
    eventSocektResult(response) {
      const result = response.data.data;
      this.rightToVoteuserList = result.online_right_to_vote_users;
      this.norightToVoteuserList = result.online_without_right_to_vote_users;

      this.eventResult = {
        invited: result.voting ? result.voting : 0,
        entered: result.online_voting ? result.online_voting : 0,
        absent: result.absent ? result.absent : 0,
        voted: result.voted ? result.voted : 0,
        online_right_to_vote: result.online_right_to_vote ? result.online_right_to_vote : 0,
        online_without_right_to_vote: result.online_without_right_to_vote ? result.online_without_right_to_vote : 0,
        presents_weight: result.presents_weight ? result.presents_weight : 0,
        delegated_weight: result.delegated_weight ? result.delegated_weight : 0,
      };

      this.present_users = result.present_users

      this.$forceUpdate()
    },

    /**
     * Get event info
     * @author Madhura Shah
     */
    getEventDetails() {
      this.$vs.loading();
      this.$store
        .dispatch("getEventDetails", this.event_id)
        .then(response => {
          if (response.data.data) {
						this.showStreamRecordBtns = [1, 3].includes(response.data.data.status) ? true : false;
						this.showMomReportBtn = response.data.data.log_enabled == 1 ? true : false;
						this.is_bne = response.data.data.is_bne_room;

						if(this.showStreamRecordBtns) {
							if(response.data.data.is_streaming_started != 0)
								this.is_recording_status = response.data.data.recording_status;
						}
            this.eventAgenda = [...response.data.data.event_agenda];
						this.votingResult = response.data.data.voteResults.map(vr => this.createvotingResultObj(vr));
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getEventDetails() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    /**
     * Get vote info
     * @author Madhura Shah
     */
    getVoteInfo(voteId) {
      this.$vs.loading();
      this.$store
        .dispatch("getVoteInfo", {id: voteId})
        .then(response => {
          this.voteInfo = response.data.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getVotedValues() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    /**
     * Get vote info
     * @author Madhura Shah
     */
    getRateResult(voteId) {
      this.$vs.loading();
      this.$store
        .dispatch("getRateResult", {id: voteId})
        .then(response => {
          this.rateResultInfo = response.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getVotedValues() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    /**
     * Get presences statuses
     * @author gpv
     */
    getPresentsStatus(voteId) {
      this.$vs.loading();
      this.$store
        .dispatch("getPresentsStatus", {id: voteId})
        .then(response => {
          this.presencesStatuses = response.data;
          this.$vs.loading.close();
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getVotedValues() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    /**
     * Start Event
     * @author Madhura Shah
     */
    startEvent() {
      this.apiObj = {event_id: this.event_id, status: "1"};
      let vm = this;
      this.$swal({
        title: this.$t('run_event.start_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
          this.$store
            .dispatch("ChangeEventStatus", vm.apiObj)
            .then(response => {
              this.event_buttons.start = true;
              this.event_buttons.end = false;
              $('.start_vote_btn').show();
              $('.start_vote_btn').attr('disabled', false);
              $('.agenda-btn').attr('disabled', false);
              this.eventMessage = "run_event.eventMessageEnd"
              this.$vs.notify({
                title: this.$t('run_event.eventStarted'),
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : startEvent() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: this.$t("Error"),
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Event Action Buttons
     * @author Taherali Sonkachwala
     * @method eventActionButtons
     */
    async eventActionButtons(status=3) {
      const request = {event_id: this.event_id, status: status};
      const prompt_config = {
        title: '',
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      };

      switch (status) {
        case 3:
          prompt_config.title = this.$t('run_event.pre_start_prompt.title');
          break;
        case 0:
          prompt_config.title = this.$t('run_event.close_pre_start_prompt.title');
          break;
        case 1:
          prompt_config.title = this.eventInfo.is_streaming_started == 1 ? this.$t('run_event.start_prompt.title') : this.$t('run_event.start_prompt.title_with_streaming');
          break;
        case 2:
          prompt_config.title = this.$t('run_event.end_prompt.title');
          break;
        default:
          break;
      }

      const prompt = await this.$swal(prompt_config);
      if(!prompt.value)
        return false;
      try{
        this.$vs.loading();
        const response = await this.$store.dispatch("ChangeEventStatus", request);
        
        if(response.data.status != 'success')
          return false;
				if(status == 2){
					this.stopRecording();
					this.stopStreaming();
				}
        if(status == 3){
					this.showStreamRecordBtns = true;
					$('.start-streaming').attr('disabled', false);
					$('.stop-streaming').attr('disabled', true);

					$('.start-recording').attr('disabled', true);
					$('.stop-recording').attr('disabled', true);
				}
				if(status == 1){
					var selectedUsers = [];
					this.$store.state.event.participants.every(function(u){
						selectedUsers.push(u.id);
					});
					this.showStreamRecordBtns = true;
					this.showMomReportBtn = true;
					var formData = new FormData();
					formData.append("new_page", '/event/'+this.eventInfo.slug);
					formData.append("users", JSON.stringify(selectedUsers));
					this.$store
					.dispatch("changeUserCurrentUrl", formData)
					.then((response) => {
					})
					.catch((error) => {
						this.$log.error(
							"File : EventUsers.vue | Function : changeUserCurrentUrl() | Error :",
							error
						);
						// Error response
						this.$vs.notify({
							title: "Failed to redirect",
							text: error,
							color: "danger",
							position: "top-center",
						});
						return false;
					});
				}
        this.$vs.notify({
          title: this.$t('run_event.eventStarted'),
          text: "",
          color: "success",
          position: "top-center"
        });
      }catch(err){
        this.$log.error('File : RunEvent.vue | Function : eventActionButtons() | Error :', err);
        // Error response
        this.$vs.notify({
          title: this.$t("Error"),
          text: err,
          color: "danger",
          position: "top-center"
        });
      }
      this.$vs.loading.close();
    },


    /**
     * End Event
     * @author Madhura Shah
     */
    endEvent() {
      this.apiObj = {event_id: this.event_id, status: "2"};
      let vm = this;
      this.$swal({
        title: this.$t('run_event.end_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t('Yes'),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t('No'),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
          this.$store
            .dispatch("ChangeEventStatus", vm.apiObj)
            .then(response => {
              clearInterval(this.statusCheck);
              this.start_event = true;
              this.end_event = true;
              this.eventMessage = '';
              $('.event-msg').hide();
              this.$vs.notify({
                title: this.$t('run_event.eventEnded'),
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : endEvent() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: this.$t("Error"),
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Start Voting
     * @author Madhura Shah
     */
    async startVotingEvent(voting_id) {
      this.apiObj = {event_voting_id: voting_id, status: "1"};
      let vm = this;

      const result = await this.$swal({
        title: this.$t('run_event.voting_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      });
			if(!result.value)
				return false;
			
			this.$vs.loading();

			try{
				const response = await this.$store.dispatch("ChangeEventVotingStatus", vm.apiObj)
				$('#vote_start_' + voting_id).attr('disabled', true);
				$('#vote_end_' + voting_id).attr('disabled', false);
				$('.vote_msg_' + voting_id).text(this.$t('run_event.votingMessageEnd'));
        if(response.data.status=='success') {
          this.$vs.notify({
            title: this.$t('run_event.votingStarted'),
            text: "",
            color: "success",
            position: "top-center"
          });
        }else{
          this.$vs.error({
            title: this.$t('Error'),
            text: this.$t(response.data.message)
          });
        }
			}catch(error){
				this.$log.error('File : RunEvent.vue | Function : startVotingEvent() | Error :', error);
				// Error response
				this.$vs.notify({
					title: this.$t("Error"),
					text: error,
					color: "danger",
					position: "top-center"
				});
			}


			this.$vs.loading.close();
		},

    /**
     * End Voting
     * @author Madhura Shah
     */
    endVotingEvent(voting_id) {
      this.apiObj = {'voting_id': voting_id, 'event_id': this.event_id};
      let vm = this;
      this.$swal({
        title: this.$t('run_event.end_voting_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
          this.$store
            .dispatch("endVoting", vm.apiObj)
            .then(response => {
              clearInterval(this.votingResultIv[voting_id]);
              $('#vote_publish_' + voting_id).attr('disabled', false);
              this.getEventDetails();
              $('.vote_msg_' + voting_id).text(this.$t('run_event.votingMessage'));
              this.$vs.notify({
                title: this.$t('run_event.votingEnded'),
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : endVotingEvent() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Error",
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

		createvotingResultObj(res) {
			return {
				present_voted_users: res.present_voted_users,
				present_not_voted_users: res.present_not_voted_users,
				'event_voting_id': res.voting_id,
        'present': res.present ? res.present : 0,
        'absent': res.absent ? res.absent : 0,
        'voted': res.voted ? res.voted : 0,
        'not_answered': res.not_answered ? res.not_answered : 0,
        'present_voted': res.present_voted ? res.present_voted : 0,
        'present_not_voted': res.present_not_voted ? res.present_not_voted : 0,
        'yesVotes': res.yesVotes ? res.yesVotes : 0,
        'noVotes': res.noVotes ? res.noVotes : 0,
        'abstained': res.abstained ? res.abstained : 0,
        'quorum': res.quorum ? res.quorum : false,
				candidateResult: res.elected_candidates !== undefined ? res.elected_candidates : [],
				userVotedList: res.user_votings !== undefined ? res.user_votings : [],
				optionResult: res.option_votes !== undefined ? res.option_votes : []
      };
		},

    /**
     * Voting Result
     * @author Madhura Shah
     */
    votingSocketResult(response) {
			const votingResult = this.createvotingResultObj(response.data.data);
			
			const idx = this.votingResult.findIndex(vr => vr.event_voting_id == response.data.data.voting_id);
			
      if(idx < 0)
      	this.votingResult.splice(this.votingResult.length,0,votingResult); // push new if not exists
			else
				this.$set(this.votingResult, idx, votingResult); // update with reactive properties
      // this.$forceUpdate()
    },

    /**
     * Publish Event
     * @author Madhura Shah
     */
    publishVoting(voting_id) {
      this.apiObj = {event_voting_id: voting_id, status: "3"};
      let vm = this;

      this.$swal({
        title: this.$t('run_event.publish_voting_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();

          this.$store
            .dispatch("ChangeEventVotingStatus", vm.apiObj)
            .then(response => {
              $('#vote_publish_' + voting_id).attr('disabled', true);
              this.$vs.notify({
                title: this.$t('run_event.votingPublished'),
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : publishVoting() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: this.$t("Error"),
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Reset Event
     * @author Madhura Shah
     */
    resetEvent() {
      this.$swal({
        title: "Are you sure to reset the event?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
        this.$vs.loading();
        // clearIntervals voting
        clearInterval(this.votingResultIv);
        this.votingResultIv = [];

				this.stopStreaming();
        this.$store
          .dispatch("resetEvent", this.event_id)
          .then(response => {
						this.showStreamRecordBtns = false;
            this.getEventDetails();
            $('.agenda-btn').show();
            $('.agenda-btn').attr('disabled', true);
            $('.start_vote_btn').show();
            $('.start_vote_btn').attr('disabled', true);
            $('.end_vote_btn').show();
            $('.end_vote_btn').attr('disabled', true);
            this.eventResult = {};
            this.$vs.notify({
            title: this.$t('run_event.eventResetSuccess'),
              text: "",
              color: "success",
              position: "top-center"
            });
            this.$vs.loading.close();
          })
          .catch(error => {
            this.$log.error('File : RunEvent.vue | Function : resetEvent() | Error :', error);
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
            title: this.$t('run_event.eventResetFail'),
              text: error,
              color: "danger",
              position: "top-center"
            });
            return false;
          });
        }
      })
    },

    /**
     * Hide Voting
     * @author Madhura Shah
     */
    hideVotingEvent(voting_id) {
      this.apiObj = {event_voting_id: voting_id, status: "4"};
      let vm = this;

      this.$swal({
        title: "Are you sure to hide this voting?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();

          this.$store
            .dispatch("ChangeEventVotingStatus", vm.apiObj)
            .then(response => {
              $('#vote_hide_' + voting_id).hide();
              $('#vote_publish_' + voting_id).hide();
              this.$vs.notify({
                title: "Voting hidden successfully",
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : hideVotingEvent() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Error",
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Publish Agenda
     * @author Madhura Shah
     */
    publishAgenda(id) {
      this.apiObj = {id: id, status: "1"};
      let vm = this;

      this.$swal({
        title: "Are you sure to publish this agenda?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();

          this.$store
            .dispatch("updateAgendaStatus", vm.apiObj)
            .then(response => {
              $('#agenda_publish_' + id).attr('disabled', true);
              this.$vs.notify({
                title: "Agenda published successfully",
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : publishAgenda() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: "Error",
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Hide Agenda
     * @author Madhura Shah
     */
    hideAgenda(id) {
      this.apiObj = {id: id, status: "4"};
      let vm = this;

      this.$swal({
        title: "Are you sure to hide this agenda?",
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#7367F0",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();

          this.$store
            .dispatch("updateAgendaStatus", vm.apiObj)
            .then(response => {
              $('#agenda_hide_' + id).hide();
              $('#agenda_publish_' + id).hide();
              this.$vs.notify({
                title: this.$t('run_event.agendaSuccess'),
                text: "",
                color: "success",
                position: "top-center"
              });
              this.$vs.loading.close();
            })
            .catch(error => {
              this.$log.error('File : RunEvent.vue | Function : hideAgenda() | Error :', error);
              this.$vs.loading.close();
              // Error response
              this.$vs.notify({
                title: this.$t("Error"),
                text: error,
                color: "danger",
                position: "top-center"
              });
              return false;
            });
        }
      });
    },

    /**
     * Get event Result
     * @author Madhura Shah
     */
    getEventResult() {
      this.$store
        .dispatch("getEventResult", this.event_id)
        .then(response => {
          this.eventSocektResult(response);
        })
        .catch(error => {
          console.log(error);
          this.$log.error('File : RunEvent.vue | Function : getEventResult() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t('FailedToLoadData'),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    /**
     * Get voting Result
     * @author Madhura Shah
     */
    getVotingResult(voting_id) {
      this.$store
        .dispatch("getVotingResult", voting_id)
        .then(response => {
          this.votingSocketResult(response);
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : getVotingResult() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t('FailedToLoadData'),
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
    exportToExcel() {

      if (this.rateToExport) {
        import('@/utils/Export2Excel').then(excel => {
					const vr = this.votingResult.find(vr => vr.event_voting_id == this.rateToExport);
          const list = vr ? vr.userVotedList : [];
          const data = this.formatJson(this.headerVal, list);
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: this.fileName,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
          this.rateToExport = 0;
        })
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields() {
      this.filename = '';
      this.cellAutoWidth = true;
      this.selectedFormat = 'xlsx';
    },
    exportVotesToExcel() {
      if (this.rateToExport) {
        import('@/utils/Export2Excel').then(excel => {
          const list = this.voteInfo;
          const data = this.formatJson(this.votesHeaderVal, list);
          excel.export_json_to_excel({
            header: this.votesHeaderTitle,
            data,
            filename: this.fileName,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
          this.rateToExport = 0;
        })
      }
    },
    exportRateResultToExcel() {
      if (this.rateResultInfo) {
        import('@/utils/Export2Excel').then(excel => {
          const list = this.rateResultInfo;
          const data = this.formatJson(this.rateResultHeaderVal, list);
          excel.export_json_to_excel({
            header: this.rateResultHeaderTitle,
            data,
            filename: this.fileName + " - Rate Result",
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
          this.rateToExport = 0;
        })
      }
    },
    exportPresencesStatuses() {
      if (this.rateResultInfo) {
        import('@/utils/Export2Excel').then(excel => {
          const list = this.presencesStatuses;
          const data = this.formatJson(this.presencesStatusesHeaderVal, list);
          excel.export_json_to_excel({
            header: this.presencesStatusesHeaderTitle,
            data,
            filename: this.fileName + " - Presences Status",
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat
          })
          this.clearFields()
          this.rateToExport = 0;
        })
      }
    },
		async repeatVotingEvent(vote) {
			const result = await this.$swal({
        title: this.$t('run_event.repeat_voting_prompt.title'),
        text: this.$t('YouCantRevertYourAction'),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      if (!result.value)
				return false;

			
			try{
				const nVote = {
          timer: vote.timer,
          event_id: vote.event_id,
          voting_name: vote.voting_name,
          voting_description: vote.voting_description,
          voting_start_date: vote.voting_start_date,
          voting_end_date: vote.voting_end_date,
          type_of_voting: vote.type_of_voting,
          quorum_type: vote.quorum_type.id,
          is_secret: vote.is_secret,
          opening_mode: vote.opening_mode,
          id: vote.id,
          candidate_number: vote.candidate_number,
          candidates: vote.candidates,
          number_of_candidates_elect: vote.number_of_candidates_elect,
          preference_no: vote.preference_no,
          option_number: vote.option_number,
          options: vote.options.map(o => ({options:o.options, is_enabled: o.is_enabled}))
				};
        this.$vs.loading();
				const response = await this.$store.dispatch('addNewVoting', nVote);
				if(response.data.status == 'success') {
					this.$vs.notify({
						title: this.$t('run_event.repeat_voting_prompt.success'),
						color: 'success'
					});
          this.$store.commit('UPDATE_EVENT_VOTING', response.data.data);
          this.getVotingResult(response.data.data.id);
				}else
					throw response.data.message;
			}catch(error) {
				console.error(error)
				this.$log.error('File : RunEvent.vue | Function : repeatVotingEvent() | Error :', error);
        // Error response
        this.$vs.notify({
          title: this.$t('run_event.repeat_voting_prompt.error'),
          text: error,
          color: "danger",
          position: "top-center"
        });
			}
			this.$vs.loading.close();
		},
		/**
     * downloadMomFile
     * @author Bhagwan Sawant
     */
		downloadMomFile() {
      this.$vs.loading();
      this.$store
        .dispatch("downloadMom", {'event_id': this.$route.params.id, 'lang' : this.$i18n.locale})
        .then(res => {
          this.$vs.loading.close();
          var data = res.data;
          // Success response
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "event_mom.docx"
          );
          document.body.appendChild(fileLink);

          fileLink.click();

          this.$vs.notify({
            color: "success",
            title: "Download Success",
            text: "File downloaded successfully!!",
            position: "top-center"
          });
        })
        .catch(error => {
          this.$log.error('File : RunEvent.vue | Function : downloadMomFile() | Error :', error);
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to download file, please try again",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },
  }
};
</script>
<style scoped>
.titlevx-card {
  width: 97%;
  margin: 0 auto;
  margin-bottom: 2% !important;
}

.vs-popup--background {
  opacity: 0.2 !important;
  background: none !important;
}
</style>
